import React from "react";
import { useSelector } from "react-redux";
import Navbar from "../../components/Navbar";
import AssignmentQuizz from "../../components/StudentPortal/CoursePlayer/AssignmentQuizz";
import Description from "../../components/StudentPortal/CoursePlayer/Description";
import Player from "../../components/StudentPortal/CoursePlayer/Player";
import VideoTitle from "../../components/StudentPortal/CoursePlayer/VideoTitle";
import VideosList from "../../components/StudentPortal/CoursePlayer/VideosList";
import { useGetAssignmentsQuery } from "../../features/assignments/assignmentsApi";
import { useGetQuizzesQuery } from "../../features/quizzes/quizzesApi";
import { useGetVideoQuery } from "../../features/videos/videosApi";

export default function CoursePlayer() {
  const { currentPlayId } = useSelector((state) => state.videos);

  const { data: video } = useGetVideoQuery(currentPlayId) || {};
  const { data: assignments } = useGetAssignmentsQuery() || {};
  const { data: quizzes } = useGetQuizzesQuery() || {};

  const { title, createdAt, url, description, id } = video || {};

  let hasAssignment = false;
  const assignmentInfo = assignments?.find(
    (assignment) => id === assignment.video_id
  );

  if (assignmentInfo) {
    hasAssignment = true;
  }

  let hasQuiz = false;
  const quizInfo = quizzes?.find((quiz) => id === quiz.video_id);

  if (quizInfo) {
    hasQuiz = true;
  }

  return (
    <>
      <Navbar />

      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-7xl px-5 lg:px-0">
          <div className="grid grid-cols-3 gap-2 lg:gap-8">
            <div className="col-span-full w-full space-y-8 lg:col-span-2">
              <Player url={url} title={title} />

              <div>
                <VideoTitle title={title} date={createdAt} />

                <AssignmentQuizz
                  has={hasAssignment}
                  assignment={assignmentInfo}
                  hasQuiz={hasQuiz}
                  quiz={quizInfo}
                  videoId={id}
                />

                <Description description={description} />
              </div>
            </div>

            <VideosList />
          </div>
        </div>
      </section>
    </>
  );
}
